const base = {
  siteUrl: "https://barilga.lvg.mn/",
  baseUrl: "https://admin-barilga.lvg.mn/",
  cdnUrl: "https://barilga.lvg.mn/uploads/",
  apiUrl: "https://barilga.lvg.mn/api/v1/",
};

export default base;
